
import React, { useState } from 'react'
import '../assets/faqCategorie.css'


function FaqCategorie() {
  const [activeItem, setActiveItem] = useState(true);

  function isActive(){

  }

  return (
    <div className='container faq'>
        <div className='text-center paragraphe'>
            <p className='p1'>FAQ</p>
            <p className='p2'>NOTRE FAQ SUR LES BEST SELLER</p>
        </div>
        {/* accordion faq */}
        <div className="accordion accordion-flush faq-accordion" id="accordionFlushExample">
          <div className="accordion-item mb-3">
            <h2 className="accordion-header" id="flush-headingOne">
              <button className="accordion-button faq-acc-btn collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                Qu’est ce que le CBD ?
              </button>
            </h2>
            <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
              <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the first item's accordion body.</div>
            </div>
          </div>
          <div className="accordion-item mb-3">
            <h2 className="accordion-header" id="flush-headingTwo">
              <button className="accordion-button collapsed faq-acc-btn" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                La différence entre CBD CBG ?
              </button>
            </h2>
            <div id="flush-collapseTwo" className="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
              <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the second item's accordion body. Let's imagine this being filled with some actual content.</div>
            </div>
          </div>
          <div className="accordion-item mb-3">
            <h2 className="accordion-header" id="flush-headingThree">
              <button className="accordion-button collapsed faq-acc-btn" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                Quelle qualité propose Shoptacbd ?
              </button>
            </h2>
            <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
              <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the third item's accordion body. Nothing more exciting happening here in terms of content, but just filling up the space to make it look, at least at first glance, a bit more representative of how this would look in a real-world application.</div>
            </div>
          </div>
          <div className="accordion-item mb-3">
            <h2 className="accordion-header" id="flush-headingFor">
              <button className="accordion-button collapsed faq-acc-btn" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFor" aria-expanded="false" aria-controls="flush-collapseFor">
                Qu’est ce que c’est que le HHC et ses variantes HHC-O, HHC-P ?
              </button>
            </h2>
            <div id="flush-collapseFor" className="accordion-collapse collapse" aria-labelledby="flush-headingFor" data-bs-parent="#accordionFlushExample">
              <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the third item's accordion body. Nothing more exciting happening here in terms of content, but just filling up the space to make it look, at least at first glance, a bit more representative of how this would look in a real-world application.</div>
            </div>
          </div>
          <div className="accordion-item mb-3">
            <h2 className="accordion-header" id="flush-headingFive">
              <button className="accordion-button collapsed faq-acc-btn" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                Est ce que c’est légal d’acheter du CBD ?
              </button>
            </h2>
            <div id="flush-collapseFive" className="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
              <div className="accordion-body">Placeholder content for this accordion, which is intended to demonstrate the <code>.accordion-flush</code> class. This is the third item's accordion body. Nothing more exciting happening here in terms of content, but just filling up the space to make it look, at least at first glance, a bit more representative of how this would look in a real-world application.</div>
            </div>
          </div>
        </div>
        {/* end accordion */}
    </div>
  )
}

export default FaqCategorie